import { ol_LayerBase, ol_Collection, ol_source, ol_layer } from "@omnia/exports/openlayers"
import { Basemap } from "../../../map/basemaps/basemap"
import { BasemapGroup } from "../../../map/basemaps/group"
import { BasemapKey, IBasemapGroup } from "../../../map/types"
import { IOmniaSettings } from "../../../types"

const keys: { [key in "water" | "wind"]: BasemapKey } = {

    water: {
        label: "Bare soil water erosion risk",
        entries: [
            { color: "#54aeb3", label: "Not applicable" },
            { color: "#006100", label: "Low", note: "Sediment rarely seen to move, but be aware of soil run-off" },
            { color: "#7aab00", label: "Low-moderate", note: "Rarely rills may form during very wet periods. Sediment seen in run-off" },
            { color: "#ffff00", label: "Moderate", note: "Rills form during very wet periods. Sediment seen in run-off" },
            { color: "#ff9900", label: "High", note: "Rills likely to form during very wet periods. Sediment seen in run-off" },
            { color: "#ff2200", label: "Very high", note: "Rills likely to form most seasons and gullies in very wet periods" },
        ]
    },

    wind: {
        label: "Bare soil wind erosion risk",
        entries: [
            { color: "#97dbf2", label: "Not applicable" },
            { color: "#2892c7", label: "Soil is not prone" },
            { color: "#bfd48a", label: "Soil may be prone" },
            { color: "#fcb344", label: "Soil is prone" },
            { color: "#e81515", label: "Soil is very prone" },
        ]
    }

}

const extent = [49.846240, -8.349305, 60.872383, 2.705428]

function createUKSOBasemap(layer: ol_layer.Image<any>, name: string, wmsLayer: string, key: BasemapKey) {

    const year = new Date().getFullYear()

    const createSource = () => new ol_source.ImageWMS({
        url: "https://map.bgs.ac.uk/arcgis/services/UKSO/UKSO_BGS/MapServer/WMSServer",
        params: { "LAYERS": wmsLayer },
        ratio: 1,
        serverType: 'geoserver',
        attributions: <any>`Contains British Geological Survey materials © UKRI ${year}`
    })

    return new Basemap(name, layer, createSource, extent, key)

}

export function createUKSOBasemaps(targetLayers: ol_Collection<ol_LayerBase>, settings: IOmniaSettings): IBasemapGroup {

    const layer = new ol_layer.Image()
    layer.setOpacity(0.7)

    targetLayers.insertAt(0, layer)

    const basemaps = [

        createUKSOBasemap(
            layer,
            "Bare soil water erosion",
            "Parent.Material.Bare.Soil.Erosion,Parent.Material.Bare.Soil.Erosion.1km",
            keys.water
        ),

        createUKSOBasemap(
            layer,
            "Bare soil wind erosion",
            "Parent.Material.Bare.Soil.Wind.Erosion,Parent.Material.Bare.Soil.Wind.Erosion.1km",
            keys.wind
        ),

    ]

    const config = new BasemapGroup(
        "ukso",
        basemaps,
        layer,
        settings,
        true,
        false,
        {
            visible: false
        }
    )

    config.showKey = true

    return config

}
